import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { isValidElement } from 'react'

type Entry = { key: string; value: string | string[] | JSX.Element | undefined; private?: boolean }

interface DataTableProps {
    isPrivateDataAvailable?: boolean
    data: (Entry | undefined)[]
}

const renderEntryValue = (value: any) => {
    if (isValidElement(value)) return value
    if (Array.isArray(value)) return value.map((v, i) => <p key={i}>{v}</p>)
    if (value !== undefined) return value
    return '--'
}

export const DataTable = ({ data, isPrivateDataAvailable }: DataTableProps) => {
    return (
        <TableContainer>
            <Table sx={{ width: '100%' }}>
                <TableBody>
                    {data
                        .filter((e) => e !== undefined)
                        .map((e) => {
                            const entry = e as Entry
                            return (
                                <TableRow key={entry.key + entry.value} style={{ height: '30px' }}>
                                    <TableCell style={{ width: '200px', fontWeight: '600' }}>
                                        {entry.key}
                                        {entry.key.length > 0 && ':'}
                                    </TableCell>
                                    {entry.private &&
                                    entry.value === undefined &&
                                    !isPrivateDataAvailable ? (
                                        <TableCell style={{ color: '#0D3049' }}>
                                            <img src="/img/lock.svg" alt="" /> *********
                                        </TableCell>
                                    ) : (
                                        <TableCell style={{ color: '#0D3049' }}>
                                            {renderEntryValue(entry.value)}
                                        </TableCell>
                                    )}
                                </TableRow>
                            )
                        })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
